import { Link } from 'react-router-dom'

function Button({ children }) {
  return (
    <>
      <button className='inline-block border-2 mx-auto rounded-2xl border-blue-500 px-4 py-2 text-blue-600 text-center text-lg shadow-lg hover:bg-blue-600 hover:text-white active:scale-95 transition duration-200 ease-in-out'>
        {children}
      </button>
    </>
  )
}

export default Button
